import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/auth/authService";

// import firebase from '@firebase/app'
// import 'firebase/auth'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: '/',
                    redirect: '/dashboard'
                },
                {
                    path: '/dashboard',
                    name: 'dashboard',
                    component: () => import('./views/apps/dashboard/Dashboard.vue'),
                    meta: {
                        needAuth: true,
                        pageTitle: 'Dashboard',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/categories',
                    name: 'categories',
                    component: () => import('./views/apps/category/Category.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Categories', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Categories',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/questions',
                    name: 'questions',
                    component: () => import('./views/apps/question/AllQuestion.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Questions', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Questions',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/questions/add',
                    name: 'add-question',
                    component: () => import('./views/apps/question/AddQuestion.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Questions', url:'/questions'},
                            { title: 'Add Question', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Add Question',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/questions/view/:questionId',
                    name: 'view-question',
                    component: () => import('./views/apps/question/ViewQuestion.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Questions', url:'/questions'},
                            { title: 'View Question', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'View Question',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/questions/edit/:questionId',
                    name: 'edit-question',
                    component: () => import('./views/apps/question/EditQuestion.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Questions', url:'/questions'},
                            { title: 'Edit Question', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Edit Question',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/tests',
                    name: 'tests',
                    component: () => import('./views/apps/test/AllTest.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'All Tests', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Tests',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/tests/add',
                    name: 'add-test',
                    component: () => import('./views/apps/test/AddTest.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Tests', url:'/tests'},
                            { title: 'Add Test', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Add Test',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/tests/edit/:testId',
                    name: 'edit-test',
                    component: () => import('./views/apps/test/EditTest.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Tests', url:'/tests'},
                            { title: 'Edit Test', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Edit Test',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/packages',
                    name: 'packages',
                    component: () => import('./views/apps/package/AllPackages.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Packages', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Packages',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/packages/add',
                    name: 'add-package',
                    component: () => import('./views/apps/package/AddPackages.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Packages', url:'/packages'},
                            { title: 'Add Package', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Add Package',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/packages/edit/:packageId',
                    name: 'edit-package',
                    component: () => import('./views/apps/package/EditPackages.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Packages', url:'/packages'},
                            { title: 'Edit Package', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Edit Package',
                        roles: ['developer', 'admin'],
                        permissions: ['view_dashboard'],
                    },
                },
                {
                    path: '/students',
                    name: 'students',
                    component: () => import('./views/apps/student/student-list/StudentList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Students', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Students',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/students/add',
                    name: 'add-students',
                    component: () => import('./views/apps/student/student-add/StudentAdd.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Add Student', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Add Student',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/students/:studentId',
                    name: 'students-view',
                    component: () => import('./views/apps/student/student-edit/StudentEdit.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Students', url:'/students'},
                            { title: 'Student Details', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Students',
                        roles: ['admin'],
                        permissions: ['view_favorites'],
                    }
                },
                {
                    path: '/subscription',
                    name: 'subscription',
                    component: () => import('@/views/apps/subscription/Subscriptions.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Settings', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Settings',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/banners',
                    name: 'banners',
                    component: () => import('@/views/apps/banner/Banners.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Banners', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Banners',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/advertisements',
                    name: 'advertisements',
                    component: () => import('@/views/apps/advertisement/Advertisements.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Advertisements', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Advertisements',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/signs',
                    name: 'signs',
                    component: () => import('@/views/apps/sign/Signs.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Signs', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Signs',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/theory',
                    name: 'teories',
                    component: () => import('@/views/apps/theory/Theory.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Theory', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Theory',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
                {
                    path: '/settings',
                    name: 'settings',
                    component: () => import('@/views/apps/settings/UserSettings.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Settings', active: true },
                        ],
                        needAuth: true,
                        pageTitle: 'Settings',
                        rule: 'admin',
                        roles: ['admin', 'developer'],
                    },
                },
            ],
        },
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                {
                    path: '/login',
                    name: 'page-login',
                    component: () => import('@/views/apps/auth/Login.vue'),
                    meta: {

                    }
                },
                {
                    path: '/register',
                    name: 'page-register',
                    component: () => import('@/views/apps/auth/Register.vue'),
                    meta: {

                    }
                },
                {
                    path: '/forgot-password',
                    name: 'page-forgot-password',
                    component: () => import('@/views/apps/auth/ForgotPassword.vue'),
                    meta: {

                    }
                },
                // {
                //     path: '/reset-password',
                //     name: 'page-reset-password',
                //     component: () => import('@/views/apps/auth/ResetPassword.vue'),
                //     meta: {

                //     }
                // },
                // {
                //     path: '/pages/lock-screen',
                //     name: 'page-lock-screen',
                //     component: () => import('@/views/apps/auth/LockScreen.vue'),
                //     meta: {

                //     }
                // },
                {
                    path: '/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/apps/auth/Error404.vue'),
                    meta: {
   
                    }
                },
                // {
                //     path: '/not-authorized',
                //     name: 'page-not-authorized',
                //     component: () => import('@/views/apps/auth/NotAuthorized.vue'),
                //     meta: {
           
                //     }
                // },
            ]
        },
        {
            path: '*',
            redirect: '/error-404'
        }
    ],
})

router.beforeEach((to, from, next) => {
    const user = JSON.parse(localStorage.getItem("userInfo"))
    const needAuth = to.meta.needAuth ? to.meta.needAuth : false;

    if(needAuth) {
        if(to.meta.roles && to.meta.roles.length && user){
            let response = false
            let returnResponse = false
            let roles = to.meta.roles
            
            for (var index = 0; index < roles.length; ++index) {
                response = user.roles.includes(roles[index])
                if(response) returnResponse = true;
            }
            
            if(returnResponse) next()
            else return next({ path: '/not-authorized' });
        }
        else next({ path: '/login' });
    }

    next()
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router

